<app-modal-filler-atom
  (click)="close()"
  [index]="(index$ | async) ?? 0"
></app-modal-filler-atom>
<div
  class="fixed bottom-0 right-0 top-0 w-72 bg-white lg:w-80"
  [style.z-index]="((index$ | async) ?? 0) + 60"
>
  <div class="flex h-screen flex-col justify-between overflow-y-auto pb-16">
    <div
      class="flex items-center justify-between p-6"
      [class.pt-10]="isNotched"
    >
      <div>
        <app-select-language-block></app-select-language-block>
      </div>
      <a
        class="cursor-pointer"
        (click)="close()"
        ><i class="icon icon-cross"></i
      ></a>
    </div>
    <div
      *ngIf="!(userId$ | async) || (!(isAnonymous$ | async) && !(firebaseToken$ | async))"
      class="p-6"
    >
      <app-button-atom
        [type]="'primary'"
        [full]="true"
        [label]="'sidebar.login-signup' | translate"
        (click)="openAuthenticationModal()"
      ></app-button-atom>
    </div>
    <div class="mb-auto flex flex-col">
      <ul class="w-full">
        <li
          *ngFor="let item of items"
          class="relative w-full py-3 pl-14.5 pr-4 text-md"
        >
          <a
            [link]="item.path"
            class="flex items-center"
            (click)="close()"
          >
            <i
              class="icon absolute left-5"
              [class]="'icon-' + item.icon"
            ></i>
            <div class="font-accent text-base font-bold text-neutral-800">
              {{ item.title | translate }}
            </div>
          </a>
        </li>
      </ul>

      <div
        class="w-full"
        *ngIf="customItems"
      >
        <app-block-list [blockIdList]="customItems"></app-block-list>
      </div>
      <ul
        class="w-full"
        *ngIf="forceDistributionMode$ | async"
      >
        <li class="relative w-full py-3 pl-14.5 pr-4 text-md">
          <div
            class="flex items-center"
            (click)="resetForceDistributionMode()"
          >
            <i class="absolute left-5"></i>
            <div class="font-accent text-base font-bold text-neutral-800">
              {{ 'sidebar.see-all-distribution-modes' | translate }}
            </div>
          </div>
        </li>
      </ul>
      <ul
        *ngIf="(isAnonymous$ | async) && (firebaseToken$ | async)"
        class="mt-4 w-full border-t border-neutral-300 pt-4"
      >
        <li class="relative flex w-full items-center py-3 pl-14.5 pr-4 text-md">
          <i class="icon icon-person-circle absolute left-5"></i>
          <div class="font-accent text-base text-neutral-800">
            {{ 'sidebar.navigation.logged-as-anonymous' | translate }}
          </div>
        </li>
      </ul>
      <ul class="mt-4 w-full border-t border-neutral-300 py-4">
        <ng-container
          *ngIf="
            ((userId$ | async) && (firebaseToken$ | async)) ||
            ((isAnonymous$ | async) && (firebaseToken$ | async))
          "
        >
          <li
            class="relative flex w-full cursor-pointer items-center py-3 pl-14.5 pr-4 text-md"
            (click)="logout()"
          >
            <i class="icon icon-logout absolute left-5"></i>
            <div class="font-accent text-base font-bold text-neutral-800">
              {{ 'sidebar.navigation.disconnect' | translate }}
            </div>
          </li>
        </ng-container>
      </ul>
    </div>
  </div>
</div>
<footer
  class="fixed bottom-0 right-0 w-72 bg-white p-2 lg:w-80"
  [style.z-index]="((index$ | async) ?? 0) + 60"
>
  <div class="flex flex-col gap-2 p-6 text-sm text-neutral-600">
    <a
      [href]="cgvUrl || 'legal-links.terms-of-sale.link' | translate"
      target="_blank"
      rel="noopener noreferrer"
      class="hover:underline"
      >{{ 'legal-links.terms-of-sale.label' | translate }}</a
    >

    <a
      [href]="'legal-links.terms-of-use.link' | translate"
      target="_blank"
      rel="noopener noreferrer"
      class="hover:underline"
      >{{ 'legal-links.terms-of-use.label' | translate }}</a
    >

    <a
      [href]="'legal-links.privacy-policy.link' | translate"
      target="_blank"
      rel="noopener noreferrer"
      class="hover:underline"
      >{{ 'legal-links.privacy-policy.label' | translate }}</a
    >

    <a
      [href]="'legal-links.legal-notice.link' | translate"
      target="_blank"
      rel="noopener noreferrer"
      class="hover:underline"
      >{{ 'legal-links.legal-notice.label' | translate }}</a
    >
  </div>

  <div class="flex flex-row justify-between">
    <div
      class="h-10 w-10 bg-neutral-50"
      (click)="resetTap()"
    ></div>
    <div
      class="flex w-fit-content items-center"
      *ngIf="displayPoweredByDood"
    >
      <span class="mr-2 font-base text-xs font-normal text-neutral-800">Powered by </span>
      <a [link]="doodCorpoUrl"
        ><img
          class="w-20"
          src="assets/images/dood-logo/logo-dood-dark.png"
          alt="Dood"
        />
      </a>
    </div>
    <div
      class="flex w-fit-content items-center"
      *ngIf="!displayPoweredByDood && footerMessage"
    >
      <a
        [link]="footerMessageUrl"
        class="mr-2 font-base text-xs font-normal text-neutral-800"
      >
        {{ footerMessage }}
      </a>
    </div>
  </div>
  <div class="text-right text-xs text-neutral-500">Version {{ version }}</div>
</footer>
